import RoadWorksSearchField from './road-works-search-field'
import RoadWorksResults from './road-works-results'

document.addEventListener("DOMContentLoaded", function () {

    const elRoadWorksSearchField = document.getElementById("road-works__search-field");

    if (elRoadWorksSearchField) {
        RoadWorksSearchField();    
    }

    const elRoadWorksResultsWrapper = document.getElementById("road-works__results");

    if (elRoadWorksResultsWrapper) {
        new RoadWorksResults(elRoadWorksResultsWrapper);        
    }

});
